import React from 'react'
import { useGiftEnabled } from '../../lib/helpers'
import { GiftButton } from '../GiftButton'
import { UrgencyTextGreen } from '../featureVariables'
import classes from './StickyFooterContent.module.scss'
import { StickyFooterContentTitle } from './StickyFooterContentTitle'

const LOCATION = 'sticky_footer'

interface StickyFooterContentProps {
  SignUpCta: React.ComponentType<{ fullWidth?: boolean; className?: string }>
  PricingText: React.ComponentType
}

interface DesktopViewProps extends StickyFooterContentProps {
  showGiftButton?: boolean
}

interface MobileViewProps extends StickyFooterContentProps {
  showGiftButton?: boolean
}

const DesktopView = ({
  SignUpCta,
  PricingText,
  showGiftButton,
}: DesktopViewProps) => (
  <div className='d-none d-sm-flex align-items-center justify-content-between'>
    <div className='d-flex flex-wrap align-items-center'>
      <StickyFooterContentTitle className='mc-mr-sm-4' />
      <p className='mc-text-small'>
        <UrgencyTextGreen />
      </p>
    </div>
    <div className='d-flex align-items-center mc-ml-2'>
      <p className='mc-text-h7 mc-mr-2 mc-mr-md-3'>
        <PricingText />
      </p>
      {showGiftButton && (
        <div
          className={`d-flex flex-gap-2 align-items-end ${classes.invertedTertiary}`}
        >
          <GiftButton className='mc-mr-2' location={LOCATION} />
        </div>
      )}
      <SignUpCta />
    </div>
  </div>
)

const MobileView = ({
  SignUpCta,
  PricingText,
  showGiftButton,
}: MobileViewProps) => (
  <div className='d-flex d-sm-none flex-column mc-gap-3'>
    {showGiftButton ? (
      <>
        <div>
          <div className='mc-mb-2'>
            <StickyFooterContentTitle />
          </div>
          <p className='mc-font-caption'>
            <PricingText />
            {`. `}
            <UrgencyTextGreen />
          </p>
        </div>
        <div className='row'>
          <div className={`${classes.invertedTertiary} col-6`}>
            <GiftButton
              className='mc-mr-2 mc-py-2'
              location={LOCATION}
              fullWidth
            />
          </div>
          <div className='col-6'>
            <SignUpCta fullWidth className='mc-py-2' />
          </div>
        </div>
      </>
    ) : (
      <>
        <div className='d-flex align-items-center justify-content-between mc-gap-4'>
          <StickyFooterContentTitle />
          <SignUpCta />
        </div>
        <div
          className={`d-flex justify-content-between mc-gap-4 ${classes.bottomContainer}`}
        >
          <p
            className='mc-font-caption align-self-end'
            style={{ minWidth: '33%' }}
          >
            <UrgencyTextGreen />
          </p>
          <p className='mc-font-caption mc-text--right'>
            <PricingText />
          </p>
        </div>
      </>
    )}
  </div>
)

export const StickyFooterContent = ({
  SignUpCta,
  PricingText,
}: StickyFooterContentProps) => {
  const { giftEnabled } = useGiftEnabled()

  return (
    <div className='container mc-p-4'>
      <DesktopView
        SignUpCta={SignUpCta}
        PricingText={PricingText}
        showGiftButton={giftEnabled}
      />
      <MobileView
        SignUpCta={SignUpCta}
        PricingText={PricingText}
        showGiftButton={giftEnabled}
      />
    </div>
  )
}
